import TFM from 'utils/throwIfMissing';

export const changeToMode = (mode = TFM('mode') as any) => {
  return (dispatch) => {
    return dispatch({
      type: 'SETTINGS_UPDATE_MODE',
      mode,
    });
  };
};
